import { UserProfile } from "@/types/user"

export interface UserPreferences {
  userId: number
  username: string
  regions: string[]
  displayCount: number
  betFormat: "decimal" | "fractional" | "american"
  included: string[]
  excluded: string[]
  hiddenTemplates: string[]
}

export const defaultGuestPreferences: UserPreferences = {
  userId: 0,
  username: "Guest",
  regions: [],
  displayCount: 0,
  betFormat: "decimal",
  included: [],
  excluded: [],
  hiddenTemplates: []
}

export function getUserPreferences(): UserProfile | null {
  try {
    const raw = localStorage.getItem("userPreferences")
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function hasNonDefaultPreferences(prefs: UserProfile | null): boolean {
  if (!prefs) return false

  for (const key in defaultGuestPreferences) {
    const def = (defaultGuestPreferences as any)[key]
    const val = (prefs as any)[key]

    // Arrays
    if (Array.isArray(def)) {
      if (!Array.isArray(val) || val.length !== 0) return true
      continue
    }

    // Primitives
    if (val !== def) return true
  }

  return false
}
